<template>
  <b-row>
    <b-col
      v-if="loading"
      cols="12"
      class="text-center py-2"
    >
      <b-spinner variant="primary" />
    </b-col>
    <template v-else>
      <b-col
        v-for="card in statCards"
        :key="card.key"
        cols="12"
        md="4"
      >
        <b-card>
          <div class="d-flex align-items-center">
            <b-avatar
              :variant="card.color"
              size="50"
            >
              <FeatherIcon
                :icon="card.icon"
                size="20"
              />
            </b-avatar>
            <div class="ml-1">
              <div class="font-weight-bold">
                {{ card.label }}
              </div>
              <div class="font-weight-bolder font-medium-4">
                {{ card.value }}
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAvatar, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'StatsCards',
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    BSpinner,
  },
  computed: {
    loading() {
      return this.$store.getters['dashboard/loading']
    },
    active_projects() {
      return this.$store.getters['dashboard/active_projects']
    },
    active_tasks() {
      return this.$store.getters['dashboard/active_tasks']
    },
    completion_rate() {
      return this.$store.getters['dashboard/completion_rate']
    },
    statCards() {
      const rate = this.completion_rate !== null
        ? this.$t('common.percent', { value: Math.round(this.completion_rate * 100) })
        : '—'
      return [
        {
          key: 'projects',
          label: this.$t('dashboard.stats.activeProjects'),
          value: this.active_projects !== null ? this.active_projects : '—',
          icon: 'CropIcon',
          color: 'light-success',
        },
        {
          key: 'tasks',
          label: this.$t('dashboard.stats.activeTasks'),
          value: this.active_tasks !== null ? this.active_tasks : '—',
          icon: 'CheckSquareIcon',
          color: 'light-info',
        },
        {
          key: 'rate',
          label: this.$t('dashboard.stats.completionRate'),
          value: rate,
          icon: 'TrendingUpIcon',
          color: 'light-primary',
        },
      ]
    },
  },
}
</script>
